import { Component, OnInit } from '@angular/core';

import { UserflowService } from './userflow.service';

@Component({
  selector: 'wor-userflow-initializer',
  template: ''
})
export class UserflowInitializerComponent implements OnInit {
  constructor (
    private userflowService: UserflowService
  ) {}

  ngOnInit () : void {
    this.userflowService.initialize();
  }
}
